// The company's landline on the company forms. It is optional, and when given it
// is a Pakistani landline written the local way - the area code with its 0,
// then the number - in the format XXX-XXXXXXXX: 11 digits, e.g. 042-35761234
// or 052-31373737. There is no +92: the project works at district level.
//
// The field takes digits only and puts the dash in after the third as they
// are typed. It is saved as the 11 digits (04235761234) and shown dashed
// again. A number starting 03 is a mobile, and no area code starts 00 or 01.
//
// Mirrors services/landline.js in the backend, which checks it again, and
// src/utils/phone.ts in the app.

const LANDLINE_PATTERN = /^0[24-9][0-9]{9}$/;

export const LANDLINE_ERROR =
  "Landline must be 11 digits in the format XXX-XXXXXXXX, e.g. 042-35761234";

const digitsOf = (value) => String(value ?? "").replace(/\D/g, "");

/** 04235761234 -> 042-35761234 */
const dashed = (digits) =>
  digits.length > 3 ? `${digits.slice(0, 3)}-${digits.slice(3)}` : digits;

/**
 * What the field holds after a keystroke or a paste: at most 11 digits, with
 * the dash after the third - 042-35761234.
 */
export const typedLandline = (value) => dashed(digitsOf(value).slice(0, 11));

/** The message to show while the number is being typed, or "". */
export const landlineTypingError = (value) => {
  const digits = digitsOf(value);
  if (!digits) return "";
  if (digits[0] !== "0") return "Start with the area code and its 0, e.g. 042";
  if (digits[1] === "3") return "This is a mobile number - enter a landline";
  if (digits[1] === "0" || digits[1] === "1") return LANDLINE_ERROR;
  return "";
};

/**
 * The landline to save: "" when the field is left empty, or null when it is
 * not 11 digits in the format XXX-XXXXXXXX.
 */
export const landlineToSave = (value) => {
  if (!String(value ?? "").trim()) return "";
  const digits = digitsOf(value);
  return LANDLINE_PATTERN.test(digits) ? digits : null;
};

/** A saved landline as the form and the invoices show it: 042-35761234, or "". */
export const landlineForDisplay = (stored) => dashed(digitsOf(stored));
